var rcWidgetLoaded = setInterval(function(){ 
  if($('.rc_container_wrapper').length > 0){
    
    clearInterval(rcWidgetLoaded);
    var options = '<div id="custom_selling_plans" class="custom-selling_plans_options rc_block rc_block__type__options delivery_ever active"><div class="rc_label__delivery_wrapper"> <span class="rc_label__delivery">Delivery</div>';
    $(".rc-selling-plans__dropdown option").each(function(index){
      var is_active = '';
      if(index == 0){
        var is_active = 'active';
      }
      var is_recomended = '';
      var recomendedclass = '';
      if($(this).attr('data-plan-option').indexOf('2') >= 0){
        is_recomended = '<span class="recommended_text">(Recommended)</span>';
        var recomendedclass = 'recomended';
      }
      options += '<div class="but__frequency-item '+is_active+'" data-plan="'+$(this).val()+'"><span class="but-fi-label '+recomendedclass+'">'+is_recomended+''+$(this).attr('data-plan-option').replace('Delivery every','')+'</span></div>';
    });
    options += '<div>';
//     $('.rc-radio-group__options').after(options);
     $('.rc-template__button-group').after(options)
    
    $('.rc_popup').remove();
    $('#custom_selling_plans').append('<div class="rc_popup" style="display: block;"><div class="rc_popup__hover"> <div class="rc_shipping_text_icon"> <span>?</span> Free Shipping | No commitment, cancel anytime</div><div class="rc_popup__block"><div class="rc_popup__block__content"><div class="rc_popup__close" style="display: none;">x</div><p><strong>HOW IT WORKS</strong><br>To cancel your subscription, please email us at sales@irishtweedstore.com.com so we can process your cancellation to guarantee you will no longer be charged for this subscription.</p><a href="http://rechargepayments.com/subscribe-with-recharge?utm_source=shopify%20store&amp;utm_medium=customer%20link&amp;utm_campaign=Shopify%20store%20back%20link&amp;shop_name=ForChics&amp;shop=forchics.myshopify.com" target="_blank" aria-label="Learn more about ReCharge Payments">*</a></div><div class="rc_popup__block__footer"><a href="http://rechargepayments.com/subscribe-with-recharge?utm_source=shopify%20store&amp;utm_medium=customer%20link&amp;utm_campaign=Shopify%20store%20back%20link&amp;shop_name=ForChics&amp;shop=forchics.myshopify.com" target="_blank" aria-label="ReCharge Payments homepage"><img src="//rechargestatic-bootstrapheroes.netdna-ssl.com/static/images/widget/rc_widget__banner@2x.png" height="28" width="153" alt="ReCharge Subscriptions company banner" class="rc_popup__badge"></a></div></div></div></div>');

    if ($(".rc-radio-group__options").length == 0 ) {
      $('#custom_selling_plans').show();
    }
    else {
      $('#custom_selling_plans').hide();
    }

  }

},1000);
// $(document).on('click', '.rc-template__legacy-radio .rc_widget__option', function(){
//   $('.rc_widget__option__plans').hide();
// });

$(document).on('click','.not_s_close_popup,.interval-modal--body_overlay',function(){
  $('.interval-modal--body').hide();
  $('.interval-modal--body_overlay').hide();
});

$(document).on('click','.rc_not_sure',function(){
  $('.interval-modal--body').show();
  $('.interval-modal--body_overlay').show();
});


  
$(document).on('change', '.rc-template input', function(){
//   $('.rc_widget__option__plans').hide();
  if($(this).val() == 'onetime'){
    $('#custom_selling_plans').hide();
  }else if($(this).val() == 'subsave'){
    $('#custom_selling_plans').show();
  }
});

$(document).on("click", "#custom_selling_plans div.but__frequency-item",function(){
  $("#custom_selling_plans div.but__frequency-item").removeClass("active");
  $(this).addClass("active");
  let plan_id = $(this).data('plan');console.log('clicked='+plan_id);
  $("#selling_plan option").eq(plan_id).prop('selected', true);
  $("#selling_plan").val(plan_id);
  $("[name='selling_plan']").val(plan_id);
});

$(document).on('click','.rc-template__legacy-radio .rc-radio',function(){
  if($(this).hasClass('rc-option__subsave') == true){
    var dp = parseInt($('.rc_widget__option__discount').text().replace('%',''));
    $('.HorizontalList__Item .variant_pricee').each(function(){
      var sPrice = $(this).data('sprice');
      var esp = $(this).data('savep');
      var savePrice = (sPrice * dp) / 100;
      savePrice += esp;
      var fsPrice = Shopify.formatMoney(savePrice);
      $(this).text('You save '+fsPrice);
    });
    var atcp = $('.opt_save_price .rc_widget__price--subsave').text();
    $('.act_price_text span.price-item--regular').text(atcp);
  }else{
    $('.HorizontalList__Item .variant_pricee').each(function(){
      var sPrice = $(this).data('dval');
      $(this).text(sPrice);
    });
    var atcp = $('.rc_widget__price--onetime').text();
    $('.act_price_text span.price-item--regular').text(atcp);
  }
});